<script setup lang="ts">
import { reactive, ref } from 'vue';
import useMatestoreStore from '@/store/matestoreStore';
import { $alert } from '@nio-fe/lego';

const drawerVisible = ref(false);
const formData = reactive<any>({});
const openDrawer = () => {
  drawerVisible.value = true;
};
const closeDrawer = () => {
  drawerVisible.value = false;
};
const microStore = useMatestoreStore();
const decorateRequire = (action: () => any, parameters?: string[]) => {
  if (!parameters) {
    return action();
  } else {
    if (parameters.every((p) => formData[p])) {
      return action();
    } else {
      $alert('请填写完整参数: ' + parameters.join(','));
    }
  }
};
const handleReload = () => {
  console.log('handleReload', formData);
  microStore.reloadMicroApp(formData.reloadMicroName);
};

defineExpose({
  openDrawer,
  closeDrawer,
});
</script>

<template>
  <n-drawer v-model="drawerVisible" title="开发支持面板" zIndex="3000">
    <n-form>
      <n-form-item label="小程序重新加载">
        <n-input
          v-model="formData.reloadMicroName"
          placeholder="请输入小程序microName"
          clearable
        >
          <template #append>
            <n-button
              size="small"
              @click="decorateRequire(handleReload, ['reloadMicroName'])"
              >Reload</n-button
            >
          </template>
        </n-input>
      </n-form-item>
    </n-form>
  </n-drawer>
</template>

<style scoped lang="scss"></style>
